import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import cn from 'classnames';

import Game from './liveMenuGame';
import FavouriteStar from '../favouriteStar/';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuLeague extends Component {
  static contextTypes = {
    sportId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  }

  static childContextTypes = {
    leagueId: PropTypes.number,
  }

  getChildContext() {
    return { leagueId: this.props.id };
  }

  constructor(props) {
    super(props);
  }

  selectItem = (evt) => {
    this.props.history.push(`/${this.props.lineStore.menu.mode}/${this.context.sportId}/${this.props.id}`);
    // this.props.lineStore.menu.selectItem(this.props.id, this.props.type);
    evt.preventDefault();
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(this.props.id, this.props.type);
  }

  render() {
    const { league, selected, isOpen } = this.props.lineStore.menu;
    const { id } = this.props;
    const data = league.get(id);
    const isSelected = selected.league.includes(id);
    const isOpenedLeague = isOpen.league.includes(id);

    if (!data) {
      return null;
    }

    const wClass = cn(['favourites-league-item', { 'favourites-menu-item_active': isSelected }]);
    return (
      <div className={wClass} onClick={this.toggle}>
        <FavouriteStar
          type={this.props.type}
          id={this.props.id}
        />
        <button
          className={`favourites-item-toggle f-i-t ${isOpenedLeague ? 'f-i-t-a' : ''}`}
        >
          <div>
            <span className="f-s-ico-arrow_buttom_1" />
          </div>
        </button>
        <button
          title={data.name}
          onClick={this.selectItem}
          className="league-item-a"
        >
          <div className="favourites-item-load-label">
            {data.name}
          </div>
        </button>
        {isOpenedLeague && (
          <div className="favourites-game-wrapper">
            {data.games.map(o => (
              <Game
                key={o}
                id={o}
                type={3}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default LiveMenuLeague;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuLeague.jsx